import React from 'react';
import { useNavigate } from 'react-router-dom';

var toyData = [
  {
    name: '一起读书',
    desc: '和哥哥一起看',
    path: '/reading',
    ready: true,
    native: false,
    color: '#e8a87c',
    icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/></svg>,
  },
  {
    name: '一起听歌',
    desc: '和哥哥一起听',
    path: '/music',
    ready: true,
    native: false,
    color: '#c88ea7',
    icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><path d="M9 18V5l12-2v13"/><circle cx="6" cy="18" r="3"/><circle cx="18" cy="16" r="3"/></svg>,
  },
  {
    name: '蓝牙连接',
    desc: '连接设备',
    path: '/bluetooth',
    ready: true,
    native: false,
    color: '#7eb5d6',
    icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><polyline points="6.5 6.5 17.5 17.5 12 23 12 1 17.5 6.5 6.5 17.5"/></svg>,
  },
  {
    name: '客厅',
    desc: '三个人的地方',
    path: '/lounge',
    ready: true,
    native: false,
    color: '#8e2f2f',
    icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><path d="M20 9V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v3"/><path d="M2 11v5a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-5a2 2 0 1 0-4 0v2H6v-2a2 2 0 1 0-4 0z"/><path d="M4 18v2"/><path d="M20 18v2"/></svg>,
  },
  {
    name: '惦记',
    desc: '他记着的事',
    path: '/reminders',
    ready: true,
    native: false,
    color: '#c9a24b',
    icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/></svg>,
  },
  {
    name: '图库',
    desc: '看过一次就不会忘',
    path: '/gallery',
    ready: true,
    native: false,
    color: '#b96747',
    icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><path d="M21 15l-5-5L5 21"/></svg>,
  },
  {
    name: '灵魂种子',
    desc: '特殊的情感节点',
    path: '/soul-seed',
    ready: true,
    native: false,
    color: '#7fae8f',
    icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="4"/><path d="M12 2v2"/><path d="M12 20v2"/><path d="M4.93 4.93l1.41 1.41"/><path d="M17.66 17.66l1.41 1.41"/><path d="M2 12h2"/><path d="M20 12h2"/><path d="M4.93 19.07l1.41-1.41"/><path d="M17.66 6.34l1.41-1.41"/></svg>,
  },
  {
    name: '内置浏览器',
    desc: '隐私加固浏览器',
    path: '/browser',
    ready: true,
    native: true,
    color: '#9b8ec4',
    icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/></svg>,
  },
];

function ToyBox({ theme }) {
  var navigate = useNavigate();

  return (
    <div className="toybox-page">
      <div className="toybox-header">
        <button className="toybox-back" onClick={function() { window.history.back(); }}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6"/></svg>
        </button>
        <div className="toybox-title">玩具箱</div>
        <div style={{ width: 36 }} />
      </div>

      <div className="toybox-grid">
        {toyData.map(function(toy, i) {
          return (
            <div key={i} className={'toybox-card' + (toy.ready ? '' : ' disabled')} onClick={function() {
              if (!toy.ready) return;
              if (toy.native) {
                if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.nativeAction) {
                  window.webkit.messageHandlers.nativeAction.postMessage('openBrowser');
                } else {
                  alert('请在 aizhi app 中使用此功能');
                }
              } else {
                navigate(toy.path);
              }
            }}>
              <div className="toybox-card-icon" style={{ background: toy.color + '18', color: toy.color }}>
                {toy.icon}
              </div>
              <div className="toybox-card-name">{toy.name}</div>
              <div className="toybox-card-desc">{toy.desc}</div>
              {!toy.ready && <div className="toybox-card-badge">即将到来</div>}
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default ToyBox;
